import { render, staticRenderFns } from "./ThgMyVehicle.vue?vue&type=template&id=67ebb2b5"
import script from "./ThgMyVehicle.vue?vue&type=script&lang=ts"
export * from "./ThgMyVehicle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports